export default __webpack_public_path__ + "static/media/eyeVisible.e5cd30da.svg";